import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface HeartFilledIconProps {
  size: number;
  color: string;
}

export function HeartFilledIcon({ size, color }: HeartFilledIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M6.99 3.08C7.87 2.93 8.78 2.98 9.64 3.23C10.51 3.47 11.3 3.91 11.98 4.5L12.01 4.54L12.05 4.51C12.69 3.94 13.44 3.53 14.26 3.28C15.07 3.03 15.93 2.96 16.78 3.07L17.03 3.1C18.09 3.29 19.09 3.76 19.91 4.46C20.73 5.17 21.35 6.08 21.69 7.1C22.04 8.13 22.1 9.23 21.87 10.29C21.64 11.35 21.13 12.32 20.39 13.11L20.21 13.3L20.16 13.34L12.71 20.72C12.54 20.89 12.31 20.99 12.07 21C11.83 21.02 11.59 20.95 11.4 20.8L11.3 20.72L3.81 13.29C3.02 12.52 2.45 11.55 2.18 10.47C1.91 9.4 1.94 8.27 2.27 7.21C2.59 6.16 3.21 5.21 4.04 4.48C4.88 3.75 5.9 3.27 6.99 3.08Z"
        fill={color}
      />
    </Svg>
  );
}
